<div>

  <div class="row">
    <div class="col-md-8">
      <!--Row 1 Start-->
      <div class="row">
        <div class="col"><span><strong>Claim Type:</strong></span><span class="requiredField">*</span></div>
        <div class="col">
          <kendo-dropdownlist [data]="claimTypeDdlData"
                              [(ngModel)]="selectedClaimType"
                              (blur)="isClaimDetailsValid()"
                              [ngClass]="{warningErrorBorder : isClaimTypeInvalid && isSubmitClicked }"
                              textField="name" valueField="value" class="kendoInput"
                              (selectionChange)="claimTypeSelected($event)">
          </kendo-dropdownlist>
        </div>
        <div class="col"><span><strong>Scheduled Ship Date:</strong></span> </div>
        <div class="col"> <span>{{order.scheduleDateUIString}}</span></div>
      </div>
      <!--Row 1 End-->
      <!--Row 2 Start-->
      <div class="row">
        <div class="col"><span><strong>Job Name:</strong></span></div>
        <div class="col"><span>{{order.jobName}}</span></div>
        <div class="col"><span><strong>Shipped From:</strong></span> </div>
        <div class="col"><span>{{order.shipFrom}}</span></div>
      </div>
      <!--Row 2 End-->
      <!--Row 3 Start-->
      <div class="row">
        <div class="col"><span><strong>Sales Order #:</strong></span></div>
        <div class="col"><span>{{order.orderNumber}}</span></div>
        <div class="col"><span><strong>Shipped To:</strong></span></div>
        <div class="col"><span>{{fullShipToAddress}}</span></div>
      </div>
      <!--Row 3 End-->
      <!--Row 4 Start-->
      <div class="row">
        <div class="col"><span><strong>Customer Name:</strong></span></div>
        <div class="col"><span>{{fullCustomerName}}</span></div>
        <div class="col"></div>
        <div class="col"></div>
      </div>
      <!--Row 4 End-->
      <!--Row 5 Start-->
      <div class="row">
        <div class="col"><span><strong>Request Type:</strong></span><span class="requiredField">*</span></div>
        <div class="col">
          <kendo-dropdownlist [data]="requestTypeDdlData"
                              [(ngModel)]="selectedRequestType"
                              (blur)="isClaimDetailsValid()"
                              [ngClass]="{warningErrorBorder : !isRequestTypeValid && isSubmitClicked }"
                              textField="name" valueField="value" class="kendoInput"
                              (selectionChange)="requestTypeSelected($event)">
          </kendo-dropdownlist>
        </div>
        <div class="col">
          <!--<input kendoTextBox
                 (blur)="onRequestTypeCommentChanged($event)"
                 (valueChange)="onRequestTypeCommentChanged($event)"
                 [ngClass]="{warningErrorBorder : !isOtherRequestCommentValid && isSubmitClicked }"
                 [(ngModel)]="otherRequestTypeComment" />-->
        </div>
        <div class="col">

        </div>
      </div>
      <!--Row 5 End-->

    </div>
    <div class="col">
      <div class="row">
        <div class="col-md-3">
          <span><strong>Comments:</strong></span>
        </div>
        <!--</div>
        <div class="row">-->
        <div class="col-md-9">
          <!--<kendo-textarea [rows]="5"
                          [cols]="50"
                          [style.width.%]="80"
                          [(ngModel)]="claimComment"
                          [value]="">
          </kendo-textarea>-->

          <kendo-textarea rows="5" value=""
                          cols="50"
                          [style.width.%]="80"
                          [(ngModel)]="claimComment"
                          >
          </kendo-textarea>
        </div>
        </div>
      </div>
    </div>
  </div>


<hr />
<div class="row">
  <div class="col">
    <div style="float: left;" *ngIf="!this.isClaimItemSelected && isSubmitClicked"><p>Itemized Breakdown of Claim-<strong class="warningSpan">Select Items to be Claimed</strong><span class="requiredField">*</span></p></div>
    <div style="float: left;" *ngIf="!(!this.isClaimItemSelected && isSubmitClicked)"><p>Itemized Breakdown of Claim-<strong>Select Items to be Claimed</strong><span class="requiredField">*</span></p></div>
    <!--<div style="float: left;" [ngClass]="{warningErrorBorder : isClaimTypeInvalid && isSubmitClicked }"><p>Itemized Breakdown of Claim-<strong>Select Items to be Claimed</strong></p></div>-->
    <div style="float: right;" *ngIf="selectedLinesForClaim.length>0">
      <span style="color:green">Selected Lines: <b> {{selectedLinesForClaim.length}}</b></span>
    </div>
    <!--<div style="float: right;" *ngIf="!isClaimTypeInvalid && isSubmitClicked">
      <span style="color:red">Please select at least 1 item</span>
    </div>-->
  </div>
</div>
<div>
  <kendo-grid [data]="trackShipmentTabGridData"
              class="orderInquiryDetailsGridCls"
              [sortable]="true"
              [selectable]="false"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="trackShipmentGridstate.sort"
              [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
              [pageSize]="trackShipmentGridstate.take"
              [skip]="trackShipmentGridstate.skip"
              [columnMenu]="{ filter: false, sort: false }"
              (sort)="trackShipmentGridSortChange($event)"
              (pageChange)="trackShipmentGridPageChange($event)"
              (dataStateChange)="trackShipmentDataStateChange($event)"
              (columnReorder)="onShipmentReorder($event)"
              (columnVisibilityChange)="onShipmentVisibilityChange($event)"
              [filter]="trackShipmentGridstate.filter"
              [loading]="trackShipmentLoading">
    <ng-template kendoGridToolbarTemplate>
      <!--<div class="k-grid-toolbar-button-display hideToolBarBtnInPwa">
        <button kendoButton class="excel-button" icon="file-excel" [disabled]="loadingExcel" (click)="generateShipmentExcel()">
          {{orderDetailTxt.exportToExcelLbl?orderDetailTxt.exportToExcelLbl:orderDetail.exportToExcelLbl}}
          <kendo-loader *ngIf="loadingExcel"></kendo-loader>
        </button>
        <button kendoButton icon="file-pdf" class="pdf-button" [disabled]="loadingPDF" (click)="generateShipmentPDF()">

          {{orderDetailTxt.exportToPdfLbl?orderDetailTxt.exportToPdfLbl:orderDetail.exportToPdfLbl}}
          <kendo-loader *ngIf="loadingPDF"></kendo-loader>
        </button>
      </div>-->
      <!--<input placeholder="Search in all columns..."
             kendoTextBox
             (input)="onFilterTrackShipment($event.target.value)" class="pwaOrderInquiryDetailsSearch" />-->
    </ng-template>

    <!--<kendo-grid-column media="(max-width: 1024px)" title="Track Shipment">
      <ng-template kendoGridCellTemplate let-dataItem>

        <div class="row mb-2">
          <div class="col-12 descriptionPwa">
            {{dataItem.shipmentId}}- {{dataItem.carrier}}
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold descriptionPwa">{{orderDetailTxt.proNoLbl ? orderDetailTxt.proNoLbl : orderDetail.proNoLbl}}:</span> <span class="float-right-pwa"> {{dataItem.proNo}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold"> {{orderDetailTxt.noOfBoxesLbl ? orderDetailTxt.noOfBoxesLbl : orderDetail.noOfBoxesLbl}}:</span> <span class="float-right-pwa"> {{dataItem.noOfBoxes}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold"> {{orderDetailTxt.totalWeightLbl ? orderDetailTxt.totalWeightLbl : orderDetail.totalWeightLbl}}:</span> <span class="float-right-pwa"> {{dataItem.totalWeight}}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold descriptionPwa">{{orderDetailTxt.billOfLading ? orderDetailTxt.billOfLading : orderDetail.billOfLading}}:</span> <span class="float-right-pwa"> {{dataItem.billOfLoading}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero">
            <span class="txt-bold">{{orderDetailTxt.shipDateLbl ? orderDetailTxt.shipDateLbl : orderDetail.shipDateLbl}}:</span> <span class="float-right-pwa"> {{dataItem.shipDateUIString | date:'M/dd/yyyy'}}</span>
          </div>
          <div class="col-sm-4 col-md-4 paddingZero"></div>
        </div>

      </ng-template>
    </kendo-grid-column>-->
    <kendo-grid-column *ngFor="let col of gridShipmentSettings.columnsConfig"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col._width"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format" media="(min-width: 1025px)">
    </kendo-grid-column>
    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>

    <ng-template kendoGridDetailTemplate let-dataItem>
      <kendo-grid [data]="dataItem.trackChildShipments">
        <!--<kendo-grid-column media="(max-width: 1024px)">
          <ng-template kendoGridCellTemplate let-dataItem>
            <div class="row">
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Shipment ID:</span> <span class="float-right-pwa"> {{dataItem.shipmentid}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Box No:</span> <span class="float-right-pwa"> {{dataItem.boxno}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Item:</span> <span class="float-right-pwa"> {{dataItem.item}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8 col-md-8 paddingZero">
                <span class="txt-bold descriptionPwa">Item Description:</span> <span class="float-right-pwa"> {{dataItem.itemdescription}}</span>
              </div>
              <div class="col-sm-4 col-md-4 paddingZero">
                <span class="txt-bold descriptionPwa">Quantity:</span> <span class="float-right-pwa"> {{dataItem.quantity}}</span>
              </div>

            </div>
          </ng-template>
        </kendo-grid-column>-->
        id
        <kendo-grid-column field="shipmentid" title="Shipment ID" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="boxno" title="Box No" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="item" title="Item" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="itemdescription" title="Item Description" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="itemWeight" title="Weight" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate
                       let-filter
                       let-column="column"
                       let-dataItem
                       media="(min-width: 1025px)">
            <div *ngIf="dataItem.itemWeight && dataItem.itemWeight>0">
              {{dataItem.itemWeight}}
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="quantity" title="Quantity" media="(min-width: 1025px)">
        </kendo-grid-column>
        <kendo-grid-column field="quantity" title="Quantity To Claim" media="(min-width: 1025px)">
          <ng-template kendoGridCellTemplate
                       let-filter
                       let-column="column"
                       let-dataItem
                       media="(min-width: 1025px)">
            <div>
              <kendo-numerictextbox [spinners]="false" [decimals]="0"
                                    [format]="'n0'"
                                    [step]="1"
                                    [style.width.px]="50"
                                    [max]="dataItem.quantity"
                                    [autoCorrect]="true"
                                    (valueChange)="handleClaimQuantityChange($event,dataItem)"
                                    [min]="0">
              </kendo-numerictextbox>
            </div>
          </ng-template>


        </kendo-grid-column>

        <!--<ng-template kendoGridCellTemplate
                     let-filter
                     let-column="column"
                     let-dataItem
                     media="(min-width: 1025px)"
                     *ngIf="col.field =='qtyToClaim'">
          <div>
            <kendo-numerictextbox [spinners]="false" [decimals]="0"
                                  [min]="0">
            </kendo-numerictextbox>
          </div>
        </ng-template>-->
      </kendo-grid>
    </ng-template>
    <!--<ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>-->
  </kendo-grid>
</div>
<br />
<fieldset>
  <legend style="width:auto; margin-bottom: 0px; font-weight: bold; color: #1f497d;"></legend>
  <span><b>Bill of Lading notating damage at time of delivery (claims will be denied if this is not provided)</b><span class="requiredField">*</span></span><br />
  <kendo-upload [style.width.%]="100" [multiple]="true"
                (select)="bolFileSelected($event)"
                [saveUrl]="uploadSaveUrl"
                [removeUrl]="uploadRemoveUrl"
                (success)="bolFileUploadSuccess($event)"
                (complete)="bolFileUploadComplete()"
                [ngClass]="{warningErrorBorder : !isInspectionPhotoUploaded && isSubmitClicked }"
                [restrictions]="fileRestrictions"
                [(ngModel)]="bolImages">
  </kendo-upload>
</fieldset>
<br />
<fieldset>
  <legend style="width:auto; margin-bottom: 0px; font-weight: bold; color: #1f497d;"></legend>
  <span><b>Please upload Clear Photos of damage with material in its original Packaging</b><span class="requiredField">*</span></span><br />
  <!--<i style="font-size:10px;">(Allowed Files are ".jpg", ".png", ".jfif", ".pdf", ".doc", ".docx", ".csv", ".xls", ".xlsx")</i><br/>-->
  <kendo-upload [style.width.%]="100" [multiple]="true"
                (select)="materialDamagePhotoSelected($event)"
                [saveUrl]="uploadSaveUrl"
                [removeUrl]="uploadRemoveUrl"
                (success)="materialDamagePhotoUploadSuccess($event)"
                (complete)="materialDamagePhotoUploadComplete()"
                [ngClass]="{warningErrorBorder : !isItemDamagePhotoUploaded && isSubmitClicked }"
                [restrictions]="fileRestrictions"
                [(ngModel)]="damageImages">
  </kendo-upload>
</fieldset>

<i style="font-size:14px;">Files must be less than <b>{{maxFileSizeInMB}}MB</b></i>
<br />
<i style="font-size:14px;">Allowed file types: <b>{{fileRestrictionText}}</b></i>

<div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="text-align: center">
  <button kendoButton
          (click)="submitClaim()"
          class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
    Submit Claim
    <kendo-loader *ngIf="claimSubmissionInProgress"></kendo-loader>
  </button><br />
  <!--<b *ngIf="paymentInProgress">Please wait, you are being redirected to payment portal...</b>-->
</div>

<!--Ony for DEMO-->

<section>
  <kendo-dialog *ngIf="orderAcknowledgementDialog.opened"
                title="Your Freight Claim has been sent for processing"
                (close)="closeConfirmDialog()">
    <div style="text-align: center;">
      <span class="k-icon k-i-check-outline k-i-checkmark-outline k-i-success"
            style="font-size:50px;color:green"></span>
      <p>Processing may take 24-48 hours</p>
      <!--<h4>{{lblText.submitedInfo2?lblText.submitedInfo2:checkOut.submitedInfo2}}</h4>-->
      <strong>
        Claim #{{claimConfNum}}
      </strong>
      <br />
      <br />
      <p>
        <button kendoButton primary="true" style="width: 150px;" [routerLink]="['/self-service/claim-history']">Claim History</button>&nbsp;
        <button kendoButton primary="true" style="width: 200px;" [routerLink]="['/self-service/order-selection']">Raise Another Claim</button>
      </p>
    </div>
  </kendo-dialog>
</section>
